import { Typography } from "@mui/material"

type Props = {}

const EloRatingLabel = (props: Props) => {
  return <Typography variant="body1">ELO Rating</Typography>
}

export default EloRatingLabel
